import React, { useContext, useState } from 'react';
import AuthenticateModal from '../HomeDeliveryNew/AuthenticateModal';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Contexts';

const TopLoyaltyPricingBanner = () => {
  const userData = useContext(AuthContext)?.userData;
  let userName = userData?.firstName;

  const [openSignupModal, setOpenSignupModal] = useState(false);

  const handleOpenSignUpModal = () => {
    setOpenSignupModal(true);
    _.triggerGTMVirtualPageViewEvent({
      event: 'drugPageBannerClick',
      loyaltySignupPath: 'Drug_page_banner'
    });
  };

  const handleCloseSignUpModal = () => {
    setOpenSignupModal(false);
  };

  const { t } = useTranslation();

  return (
    <>
      {userName && !_.isEmpty(userName) ? null : (
        <div>
          {openSignupModal && (
            <div className="mainModal afterSignupmodal">
              <div
                className="transparentBg"
                onClick={handleCloseSignUpModal}
              ></div>
              <div className="signUpModal">
                <AuthenticateModal
                  hideAuthenticateModal={handleCloseSignUpModal}
                />
              </div>
            </div>
          )}
          <div
            className="pricingloyaltyBanner themeFocus"
            tabIndex="0"
            onClick={handleOpenSignUpModal}
            onKeyDown={e => {
              if (e.key === 'Enter') handleOpenSignUpModal();
            }}
          >
            <p className="bannerText">
              {t('Unlock members-only prices.')}
              <span>{t('Free signup.')}</span>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TopLoyaltyPricingBanner;
